module.exports = __webpack_public_path__ + "img/GH.e6b6d8a0.png";